import { Field, Formik } from 'formik'
import { ReactElement, useCallback, useEffect, useRef } from 'react'
import { useRecoilValue } from 'recoil'
import { IDeposit } from '../types/types'
import { api } from '../utils/api'
import { v4 } from 'uuid'
import { FormikProps } from 'formik/dist/types'
import { usersState } from '../states/users-state'
import { useAccountContext } from '../contexts/account-context'

const INITIAL_VALUES: Partial<IDeposit> = {
  id: undefined,
}

interface Props {
  skipUserIds?: string[]
}

const AccountUserForm = (props: Props): ReactElement => {
  const accountId = useAccountContext()
  const users = useRecoilValue(usersState)

  const formRef = useRef<FormikProps<IDeposit>>(null)
  const onSubmit = useCallback(async (values, { setSubmitting, resetForm }) => {
    try {
      const { data } = await api.post(`account/${accountId}/user/${values.user}`)

      if (data.deposit) {
        resetForm()
      }
    } catch (e) {
      console.log(e)
    }
  }, [])

  return (
    <Formik initialValues={INITIAL_VALUES} onSubmit={onSubmit} innerRef={formRef}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        // @ts-ignore
        <form onSubmit={handleSubmit}>
          <Field
            className="select select-bordered w-full min-w-8 mb-4"
            component="select"
            id="user"
            name="user">
            <option value={undefined} title={'Select user'}>
              Select user
            </option>
            {users.map((user) => {
              return (
                <option key={user.id} value={user.id}>
                  {user.firstName} {user.lastName} ({user.email})
                </option>
              )
            })}
          </Field>
          <button type="submit" className="btn btn-outline" disabled={isSubmitting}>
            Add user
          </button>
        </form>
      )}
    </Formik>
  )
}

export default AccountUserForm